import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Dashboard from '../../components/provider/dashboard';
import { Center } from "@chakra-ui/react";
import AttractiveLoadingSpinner from '../../components/global/Loading';


export default function DashBoard() {
  const location = useLocation();
  const { token, FullName, selectedRole } = location.state || {};
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);
  const [ticketToken, setTicketToken] = useState(" ");

  useEffect(() => {
    if (token) {
      fetchData(token);
    } else {
      // Handle case when token is not available
      console.error("No token available");
      // Optionally redirect to login page or show an error message
    }
  }, [token]);

  const fetchData = async (token) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/signup`,
        { FullName, role: selectedRole },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.ticketToken) {
        console.log(res.data);  
        setIsVerified(true);
        setTicketToken(res.data.ticketToken)

        //console.log(res.data.name);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error (e.g., show error message to user)
    }
  };


  useEffect(() => {
    if (isVerified) {
      sessionStorage.setItem('ticketToken', ticketToken);
        
      navigate('/provider-home');
    }
  }, [isVerified, navigate]);

  // ... existing code ...

  return (
    isVerified ? (
      <div className="App">
        <Dashboard />
      </div>
    ) : (
      <Center h="100vh">
        <AttractiveLoadingSpinner size="50px" primaryColor="#3182CE" secondaryColor="#63B3ED" />
      </Center>
    )
  );
}



    
    /*     const fetchData = async(token) =>{
        const res = await fetch('http://localhost:3000/hello',{
         method:'GET',
         headers:{
             Authorization: 'Bearer ' + token,
         },
        });
        console.log(res.data)
        //console.log("helloFromFronEndFromServer ");
     //console.log(res)
     }*/

     
    //  return (
    //   verified?(
    //     <div className="App">
    //       <Dashboard  />
    //     </div>
    //   ):(
    //     <>
    //     {alert("Verification failed! You are not allowed access.")}
    //     <div>
    //       {/* Optional: additional UI elements */}
    //     </div>
    //   </>
    //   )
    //   );
  
    

